import { ReactNode, useEffect } from 'react'
import { useAuth } from '../hooks/useAuth'

const themes = ['dark', 'midnight', 'ocean', 'aurora', 'dusk', 'sunset', 'light'] as const
type Theme = typeof themes[number]

export default function ThemeProvider({ children }: { children: ReactNode }) {
  const { user } = useAuth()

  useEffect(() => {
    const saved = localStorage.getItem('adder-theme') as Theme | null
    const theme: Theme = saved || (user?.theme as Theme) || 'dark'
    applyTheme(theme)
  }, [user?.theme])

  return <>{children}</>
}

export function applyTheme(theme: Theme) {
  const isLight = theme === 'light'
  document.documentElement.setAttribute('data-theme', theme)
  document.documentElement.setAttribute('data-base', isLight ? 'light' : 'dark')
  localStorage.setItem('adder-theme', theme)
}

export function cycleTheme() {
  const current = (document.documentElement.getAttribute('data-theme') || 'dark') as Theme
  const idx = themes.indexOf(current)
  const next = themes[(idx + 1) % themes.length]
  applyTheme(next)
  return next
}
